import {
  Component,
  OnInit,
  HostListener
} from '@angular/core';
import { PostsStoreService } from '@stop-counter/stores';
import { Destroyer } from '@apps/tools';
import { slideAnimations, toggleHeightAnimation } from '@apps/ui';
import { PostItem } from '@apps/api-interfaces';
import { Observable } from 'rxjs';

@Component({
  selector: 'sc-alert-messages',
  templateUrl: './alert-messages.component.html',
  animations: [slideAnimations, ...toggleHeightAnimation]
})
export class AlertMessagesComponent extends Destroyer implements OnInit {

  static = ['promo_prad', 'promo_gaz', 'promo_fotowoltaika'];
  visible = false;

  get alerts$(): Observable<PostItem[]> {
    return this.postStore.getItems('alert')
  }

  @HostListener('window:scroll', []) onWindowScroll() {
    if (window.pageYOffset > 50) {
      this.activeAlertMessages();
    }
  }

  constructor(private postStore: PostsStoreService) {
    super();
  }

  ngOnInit() { }

  private activeAlertMessages() {
    if (this.visible) {
      return;
    }

    this.visible = true;
  }
}
